import StorageService from './storageService';

export default class UtilityService {
  storageService;
  
  constructor() {
    this.storageService = new StorageService();
  }

  getDomain() {
    return window.location.host;
  }

  getHref(){
    return window.location.href;
  }


}